// src/services/commonService.js
import axios from 'axios';
import apiClient from '../helpers/axiosHelper';
import config from '../config';

export class CommonService {
  static async getCellphonePrefixes() {
    const response = await apiClient.get("Common/CellphonePrefixes");
    return response.data;
  }

  static async getFormationPlaces() {
    const response = await apiClient.get("Common/FormationPlaces");
    return response.data;
  }

  static async getProfessions() {
    const response = await apiClient.get("Common/Professions");
    return response.data;
  }

  static async getDocumentTypes() {
    const response = await apiClient.get("Common/DocumentTypes");
    return response.data;
  }

  static async unsubscribe(email) {
    const response = await axios.post(
      `${config.REACT_APP_BASE_URL}Common/Unsubscribe`,
      { email, source: "TPA" },
      { headers: { 'X-Make-Key': 'sfpfS14ug2ALndC7lFRHXQw2AIym/mX+tvXTBJArfmA=' } }
    );
    return response.data;
  }
}